<div *ngIf="loading && searchListLoaderContent" class="search-dropdown-container" style="position:relative ;">
    <ul class="search-dropdown" style="transition: all 0.3s ease-in-out 0s, visibility 0s linear 0.3s, z-index 0s linear 0.01s;">
        <li *ngFor="let list of search_list_loader" tabindex="0">
            <div>
                <div>
                    <a  role="link"  class="search-article-title  content-loader"
                       >
                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </a>
                    <div style="color:black;" class="search-article-sub mt-3">
                        <span>
                            <span tabindex="0 " class="content-loader"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <span class="pipe_style ml-2"><strong></strong></span>
                            <span tabindex="0" class="content-loader" >
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span>
                            <span class="pipe_style ml-2" class="content-loader"><strong></strong></span>
                            <span tabindex="0" class="content-loader">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <span class="pipe_style ml-2"><strong></strong></span>
                            <span tabindex="0" class="content-loader"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <span class="pipe_style ml-2"><strong></strong></span>
                            <span tabindex="0" class="content-loader">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span>
                            <span class="pipe_style ml-2"><strong></strong></span>
                            <span tabindex="0" class="content-loader  ml-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <span class=' content-loader  ml-2' *ngFor="let authors of search_list_loader" tabindex="0"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </li>
      
    </ul>
</div>
<div *ngIf="show_search_list" class="search-dropdown-container" style="position:relative ;">
    <ul class="search-dropdown" style="transition: all 0.3s ease-in-out 0s, visibility 0s linear 0.3s, z-index 0s linear 0.01s;">
        <li *ngFor="let list of searchedArticles" tabindex="0">
            <div>
                <div>
                    <a  role="link"  class="search-article-title" [routerLink]="['/articles/'+list.volume+'/'+list.issue+'/'+list.article_id]"
                        [innerHTML]="list.article_title | stripFootnote | highlightSearch : valueForSearch" title="{{list.article_title | stripFootnote}} ">
                    </a>
                    <div style="color:black;" class="search-article-sub">
                        <span>
                            <span tabindex="0" class="search-sub" [innerHTML]="list.article_id | highlightSearch : valueForSearch"></span>
                            <span class="pipe_style"><b>|</b></span>
                            <span tabindex="0" class="search-sub">
                                {{'article_listing.volume' | translate}} : {{list.volume}}
                            </span>
                            <span class="pipe_style"><b>|</b></span>
                            <span tabindex="0" class="search-sub">{{'article_listing.issue' | translate}} : {{changeIssue(list.issue)}}</span>
                            <span class="pipe_style"><b>|</b></span>
                            <!-- <span tabindex="0" [innerHTML]="list.doi | highlightSearch : valueForSearch" class="search-sub"></span> -->
                            <span tabindex="0" class="search-sub">
                                DOI : <span [innerHTML]="list.doi | highlightSearch : valueForSearch"></span>
                              </span>
                            <span class="pipe_style"><b>|</b></span>
                            <span tabindex="0" class="search-sub">
                                {{'article_listing.published_online' | translate}} : {{list.published_online}}
                            </span>
                            <span class="pipe_style"><b>|</b></span>
                            <span tabindex="0" class="search-sub">{{'article_listing.authors' | translate}} : </span>
                            <span>
                                <span class='activeSemicolumn search-sub' *ngFor="let authors of list.authors" tabindex="0"
                                    [innerHTML]="returnAuthor(authors) | highlightSearch : valueForSearch">
                                </span>
                            </span>
                            <p>
                                Keywords : <span class="activeSemicolumn search-sub" *ngFor="let keywords of list?.keywords" [innerHTML]="keywords | highlightSearch : valueForSearch"></span>
                            </p>
                        </span>
                    </div>
                </div>
            </div>
        </li>
        <li *ngIf="searchedArticles.length === 0 && !loading" tabindex="0">
            <!-- {{'article_listing.no_articles_found' | translate}} -->
 <div style="display: flex; flex-direction: column; align-items: center;">
                <img class="no-data-found-img" src="assets/images/not_found_img/no_data_1.webp" alt="">
               <h5 class="card-title text-head-size">{{'article_listing.no_articles_found' | translate}}</h5>
            </div>           
        </li>
    </ul>
</div>